import React, { useMemo } from 'react';
import { EXAM_STUDENT_STATES } from 'utils/Constants';

import Pill from 'components/Misc/Pill';
import { Button, Datepicker } from 'components/Misc/Form';
import { Title, Valuation } from 'components/Misc/Typography';

import { useStudentGradeStore } from 'store/user/useStudentGradeStore';

const Take = ({ gradeId, courseId, take }) => {
	// Find status info
	const state = useMemo(() => EXAM_STUDENT_STATES.find(state => state.value === take.state), [take.state]);

	// Use user's grade store
	const onChangeTake = useStudentGradeStore(state => state.onChangeTake);

	// Handle take change for student
	const onChange = (change) => onChangeTake(gradeId, courseId, take.key, change);

	return (
		<div key={take?.id} className="flex flex-col space-y-2 sm:flex-row sm:items-center sm:space-y-0">
			<Title
				title={take?.exam?.title}
				className="flex-1"
			/>

			<div className="flex space-x-2">
				<Datepicker
					name="startDate"
					value={take?.startDate}
					onChange={onChange}
				/>

				<Datepicker
					name="endDate"
					value={take?.endDate}
					onChange={onChange}
				/>

				<Pill
					theme={state?.theme}
					name={state?.text}
				/>
			
				<Valuation
					mark={take?.mark}
					type={take?.state}
				/>
				
				<Button
					small
					square
					icon="link"
					to={`/exams/results/${take?.examId}/${take?.id}`}
				/>
			</div>
		</div>
	);
};

export default Take;